import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import axios from 'axios';
import styles from './BusinessPortfolioDetail.module.css';
import detailStyles from '../JobDashboard/JobDetailNew.module.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { ArrowLeft, Home } from 'lucide-react';

const BusinessPortfolioDetail = () => {
    const { portfolioId } = useParams();
    const navigate = useNavigate();
    const [portfolio, setPortfolio] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const businessId = localStorage.getItem('loggedInBusinessId');

    useEffect(() => {
        const fetchPortfolioDetail = async () => {
            setIsLoading(true);
            try {

                const response = await axios.get(`${API_BASE_URL}/api/WorkPortfolio/GetWorkPortfolioDetail?portfolioId=${portfolioId}&businessId=${businessId}`);
                if (response.data && response.data.model) {
                    setPortfolio(response.data.model);
                }
            } catch (err) {
                setError('Failed to fetch portfolio details.');
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        if (portfolioId && businessId) {
            fetchPortfolioDetail();
        } else {
            setError("Portfolio ID or Business ID is missing.");
            setIsLoading(false);
        }
    }, [portfolioId, businessId]);

    if (isLoading) return <p>Loading...</p>;
    if (error) return <p className={styles.error}>{error}</p>;
    if (!portfolio) return <p>Portfolio not found.</p>;

    return (
        <div className={detailStyles.jobDetailNew_bgGradientPage}>
            <header className={detailStyles.jobDetailNew_header} style={{ position: 'sticky', top: 0, zIndex: 1020 }}>
                <div className={`${detailStyles.jobDetailNew_container} ${detailStyles.jobDetailNew_headerContent}`}>
                    <div className={detailStyles.jobDetailNew_headerLeft}>
                        <button onClick={() => navigate(-1)} className={`${detailStyles.jobDetailNew_button} ${detailStyles.jobDetailNew_buttonGhost}`} style={{color: 'white'}}>
                            <ArrowLeft className={detailStyles.jobDetailNew_iconMd} />
                        </button>
                        <div className={detailStyles.jobDetailNew_headerLogo}>
                            <Home className={`${detailStyles.jobDetailNew_iconMd} ${detailStyles.jobDetailNew_textAmber400}`} />
                            <span className={detailStyles.jobDetailNew_headerTitle}>Build Start</span>
                        </div>
                        <div className={detailStyles.jobDetailNew_headerSeparator}></div>
                        <div className={detailStyles.jobDetailNew_headerSubtitle}>
                            <h1>{portfolio.title}</h1>
                        </div>
                    </div>
                    <Link to={`/business-portfolios/edit/${portfolio.portfolioId}`} className={styles.editButton}>
                        Edit Portfolio
                    </Link>
                </div>
            </header>

            <main className={`${detailStyles.jobDetailNew_container} ${detailStyles.jobDetailNew_mainContent}`}>
                <div className={styles.detailContainer}>
                    <div className={styles.location}>
                        {portfolio.suburb}, {portfolio.postcode}
                    </div>
                    <div className={styles.description}>
                        <p>{portfolio.description}</p>
                    </div>

                    {portfolio.mediaUrl && portfolio.mediaUrl.length > 0 && (
                        <div className={`${styles.carouselContainer} ${styles.customCarousel}`}>
                            <Carousel showThumbs={false} infiniteLoop useKeyboardArrows showArrows={true}>
                                {portfolio.mediaUrl.map((media) => (
                                    <div key={media.id}>
                                        <img src={media.url} alt={portfolio.title} />
                                    </div>
                                ))}
                            </Carousel>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
};

export default BusinessPortfolioDetail;
